import { Capacitor } from "@capacitor/core";

interface OpenExternalUrlOptions {
    webNavigation?: "new-tab" | "same-window";
}

const navigateOnWeb = (url: string, webNavigation: OpenExternalUrlOptions["webNavigation"]) => {
    if (webNavigation === "same-window") {
        window.location.href = url;
        return;
    }

    window.open(url, "_blank", "noopener,noreferrer");
};

const openExternalUrl = async (url: string, { webNavigation = "new-tab" }: OpenExternalUrlOptions = {}) => {
    // Web browser
    if (!Capacitor.isNativePlatform()) {
        navigateOnWeb(url, webNavigation);
        return;
    }

    try {
        // Dynamic import so older builds don't fail
        const { Browser } = await import("@capacitor/browser");

        await Browser.open({ url });
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error("Failed to open external URL via Browser plugin", err);
        // Last resort fallback
        navigateOnWeb(url, webNavigation);
    }
};

export default openExternalUrl;
